import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingLoginButton from './components/FloatingLoginButton';
import Home from './pages/Home';
import PremiumMilk from './pages/PremiumMilk';
import PharmApp from './pages/PharmApp';
import Investors from './pages/Investors';
import Contact from './pages/Contact';
import EmployeeLogin from './pages/EmployeeLogin';
import AdminVisual from './pages/AdminVisual';
import Traceability from './pages/Traceability';
import FeedTheCows from './pages/FeedTheCows';
import RACProgram from './pages/RACProgram';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/premium-milk" element={<PremiumMilk />} />
            <Route path="/pharmapp" element={<PharmApp />} />
            <Route path="/investors" element={<Investors />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/employee" element={<EmployeeLogin />} />
            <Route path="/admin-visual" element={<AdminVisual />} />
            <Route path="/trace/:batchId" element={<Traceability />} />
            <Route path="/feed-the-cows" element={<FeedTheCows />} />
            <Route path="/rac-program" element={<RACProgram />} />
          </Routes>
        </main>
        <Footer />
        <FloatingLoginButton />
      </div>
    </Router>
  );
}

export default App;
